import PerformanceMetrics from './PerformanceMetrics';
import PropertyCharts from './PropertyCharts';

export default function PortfolioComposition() {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
      <h2 className="text-primary mb-8 text-center">Property Types & Strategy</h2>
      <PropertyCharts />
      <PerformanceMetrics />
    </div>
  );
}